import type { ReactNode } from 'react';

/**
 * A modern browser-window frame around a product mockup: a chrome bar with
 * macOS traffic-light dots and a centered address pill, then the fixed-height
 * screen viewport. The chrome is always LTR (like a real browser) while the
 * screen inside keeps its own dir/font/palette.
 */
export function BrowserFrame({ host, children }: { host: string; children: ReactNode }): JSX.Element {
  return (
    <div className="plate-frame">
      <div className="plate-chrome" dir="ltr">
        <span className="plate-dots" aria-hidden>
          <span className="plate-dot" style={{ background: '#ff5f57' }} />
          <span className="plate-dot" style={{ background: '#febc2e' }} />
          <span className="plate-dot" style={{ background: '#28c840' }} />
        </span>
        <span className="plate-url">{host}</span>
        <span className="plate-dots-spacer" aria-hidden />
      </div>
      <div className="plate-screen">{children}</div>
    </div>
  );
}
